import { NgModule } from '@angular/core'

import { PatientFieldModule } from './patient-field/patient-field.module'

@NgModule({
  imports: [PatientFieldModule]
})
export class FormExtensionsModule {
  static forRoot() {
    return {
      ngModule: FormExtensionsModule,
      providers: []
    }
  }
}
